/** GET de acciones permitidas: catálogo de acciones por estado de servicio, con normalizador de variantes de campos y agrupador por estado para el modal de acciones. */
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiCall } from "../apiHelper";

export interface AccionPermitida {
  estado: string;
  codigo: string;
  mensaje: string;
}

const ESTADO_KEYS = ["estado", "nombreEstado", "estadoServicio"];
const CODIGO_KEYS = ["codigo", "codigoAccion", "tipoAccion", "accion"];
const MENSAJE_KEYS = ["mensaje", "descripcion", "descripcionAccion", "nombreAccion"];

const firstString = (src: Record<string, unknown>, keys: string[]): string => {
  const found = keys
    .map((k) => src[k])
    .find((v) => typeof v === "string" && (v as string).trim().length > 0);
  return typeof found === "string" ? found.trim() : "";
};

export const normalizarAccionesPermitidas = (raw: unknown): AccionPermitida[] => {
  let items: unknown = raw;
  if (typeof items === "string") {
    try {
      items = JSON.parse(items);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(items)) return [];

  return items
    .map((itemRaw) => {
      if (typeof itemRaw !== "object" || itemRaw === null) return null;
      const item = itemRaw as Record<string, unknown>;
      const estado = firstString(item, ESTADO_KEYS);
      const codigo = firstString(item, CODIGO_KEYS);
      const mensaje = firstString(item, MENSAJE_KEYS);
      if (!estado && !codigo) return null;
      return { estado, codigo, mensaje };
    })
    .filter((x): x is AccionPermitida => x !== null);
};

export const agruparAccionesPorEstado = (acciones: AccionPermitida[]): Record<string, string[]> => {
  const grupos: Record<string, string[]> = {};
  for (const a of acciones) {
    const key = a.estado || "SIN ESTADO";
    (grupos[key] ??= []).push(a.codigo);
  }
  return grupos;
};

export const GETAccionesPermitidas = (codEmpresa: string, codSucursal: string) =>
  apiCall<AccionPermitida[]>({
    method: "get",
    url: `${API_ENDPOINTS.GET_ACCIONES_PERMITIDAS}?codEmpresa=${codEmpresa || ""}&codSucursal=${codSucursal || ""}`,
  });